import { TFunction } from "i18next";
import { ShortcutDef } from "./context-action";

type Nullable<T> = T | null | undefined;
export const getFirstString = (...values: Nullable<string>[]): string | undefined => {
  return values.find((el) => el != null) as string | undefined;
};
export const optT = (t: TFunction, textKey?: string): Nullable<string> => {
  return textKey ? t(textKey) : undefined;
};

export const getShortcutText = (shortcut: ShortcutDef): string => {
  const modifiers = shortcut.modifiers.map((it) => `${it[0].toUpperCase()}${it.substring(1)}+`);
  const upperKey = shortcut.key.toUpperCase();
  return `${modifiers.join("")}${upperKey}`;
};
